import { httpGet, camelify } from '@/lib/api/rest';

export function fetchSession(httpGet, camelify) {
  let cache;
  return async function execute() {
    /* istanbul ignore next: development data */
    if (process.env.DEMO) {
      return '';
    }
    if (cache == null) {
      try {
        const { data } = await httpGet('/sessions');
        cache = camelify(data);
      } catch (error) {
        if (error && error.response && error.response.status === 404) return false;
        throw error;
      }
    }
    return cache;
  };
}

export default fetchSession(httpGet, camelify);
